import { SnackbarKey, useSnackbar } from 'notistack';

import CloseIcon from 'assets/icons/Cross.svg?react';
import style from 'components/snackbar/snackbarCloseButton.module.scss';

export const SnackbarCloseButton = ({ id }: { id: SnackbarKey }) => {
  const { closeSnackbar } = useSnackbar();

  return (
    <button
      className={style.closeButton}
      data-testid="btnCloseSnackbar"
      onClick={() => closeSnackbar(id)}
    >
      <CloseIcon />
    </button>
  );
};
